import Backbone from 'backbone'
import user from '../user'

const TitleModel = Backbone.Model.extend({
    defaults() {
        return {
            name: null,
            items: null,
            color: null,
            image_prefix: null,
            custom_widths: [],
            free: false,
            purchased: false,
            mode: 'page',
            question_list: [],
            test: null,
            test_available: false,
            pdf: null,
        }
    },

    initialize() {
        // if it is purchased set it
        this.purchased()

        // otherwise wait until it is
        this.listenTo(user.get('purchased'), 'add', this.purchased)

        // and listen to the user for the logout
        this.listenTo(user, 'change', this.purchased)

        // Listen for removal from any collection
        this.listenTo(this, 'remove', this.onRemove)
    },

    onRemove() {
        // Stop all event listening from this model
        this.stopListening()
        // If you have references like `this.test`, you might also do:
        this.test && this.test.stopListening && this.test.stopListening()
    },

    purchased() {
        this.set('purchased', user.get('purchased').purchased())
    },
})

export default TitleModel
